import React from "react";
import {
  ContentContainer,
  Heading,
  Button,
  P,
} from '../../../../styles'

export default function ClearFilters({
  handleAccept
}) {
  return (<ContentContainer>
    <Heading
      type={'h4'}
      children={'Clear Filters'}
      color={`blue`}
    />
    <P>{'Are you sure you want to clear all selected filters?'}</P>
    <Button
      onClick={(e) => handleAccept(e)}
      maxWidth={`48%`}
      margin={`4% 4% 0 0`}
    >
      {'Confirm'}
    </Button>
  </ContentContainer>);
}
